import React from "react"

const HtmlContent = ({ data }) => {
  if (!data) return <div></div>
  return (
    <div
      className="max-w-screen-xl w-full mx-auto lg:mt-[117px] mt-10 px-7 2xl:px-0 pb-6 lg:pb-20"
      dangerouslySetInnerHTML={{ __html: data }}
    ></div>
  )
}

export default HtmlContent
